import { Component, OnInit } from '@angular/core';
import {LoginComponent} from '../../home/login/login.component';
import {MdDialog} from '@angular/material';
import { Router } from '@angular/router';
import {AuthenticationService} from '../../auth/authentication.service';

@Component({
  selector: 'distributor-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.css', '../../app.component.css']
})

export class DistributorHeaderComponent implements OnInit {

  spinner:boolean = false;
  userInfo: any;

  constructor(public dialog: MdDialog, public auth: AuthenticationService, private router: Router) { }

  ngOnInit() {
   if(this.auth.loggedIn())
   this.userInfo = JSON.parse(localStorage.userInfo);
  }

  loginDialog() {
    let dialogRef = this.dialog.open(LoginComponent);
    dialogRef.componentInstance.onLogin.subscribe(() => {
     dialogRef.close();
    });
  }

  logout() {
   this.spinner = true;
   localStorage.removeItem('eventId');
   this.auth.logout().subscribe(
    response => {
     this.spinner = false;
     if (response === true)
     this.router.navigate(['/home']);
    },
    error => {
     this.spinner = false;
    }
   );
  }

}



// WEBPACK FOOTER //
// /var/www/html/nissco_event_web/angular/src/app/distributor/header/header.component.ts